<template>
    <div>
        <lable>質問分類</lable>
    </div>
</template>
<script>
export default {
    
}
</script>